import { Alert, Button, CardContent, CardHeader, CircularProgress, Stack, Typography } from "@mui/material"
import { useState } from "react"
import { OneCard } from "lib/@components/one-card"
import { Case, CaseElse, Switch } from "lib/@components/switch"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { allPairsComparison } from "plugins/toolbox/client/controller/all-pairs-comparison.controller.js"
import { DuplicateFinderTable } from "./duplicate-finder-table"

const PANEL_IDLE = "idle"
const PANEL_RUNNING = "running"
const PANEL_EMPTY = "empty"
const PANEL_RESULTS = "results"

export function DuplicateFinderPanel() {
    const [running, setRunning] = useState(false)
    const [results, setResults] = useState(null)
    return (
        <OneCard>
            <CardHeader
                title="Duplicate Finder"
                subheader="Scans every FIQ ticket against every other ticket for similar descriptions."
                action={
                    <Button variant="contained" onClick={runScan} disabled={running}>
                        Run Scan
                    </Button>
                }
            />
            <CardContent>
                <Stack spacing={3}>
                    <Switch value={panelState()}>
                        <Case when={PANEL_RUNNING}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <CircularProgress size={20} />
                                <Typography variant="body2" color="text.secondary">
                                    Scanning the FIQ project. This takes a couple of minutes.
                                </Typography>
                            </Stack>
                        </Case>
                        <Case when={PANEL_EMPTY}>
                            <Alert severity="success">No potential duplicates found.</Alert>
                        </Case>
                        <Case when={PANEL_RESULTS}>
                            <DuplicateFinderTable results={results ?? []} />
                        </Case>
                        <CaseElse>
                            <Typography variant="body2" color="text.secondary">
                                Run a scan to see potential duplicate tickets across the whole FIQ project.
                            </Typography>
                        </CaseElse>
                    </Switch>
                </Stack>
            </CardContent>
        </OneCard>
    )

    function panelState() {
        if (running) return PANEL_RUNNING
        if (!results) return PANEL_IDLE
        if (!results.length) return PANEL_EMPTY
        return PANEL_RESULTS
    }

    async function runScan() {
        if (running) return

        setRunning(true)
        setResults(null)

        try {
            const found = await allPairsComparison()
            setResults(found ?? [])
        } catch (error) {
            errorSnackbar(`Duplicate scan failed: ${error?.message ?? "unknown error"}`)
        } finally {
            setRunning(false)
        }
    }
}
